export default "__VITE_ASSET__CCNgq5vU__"